import { useCallback } from 'react'
import { Delete, Edit } from '@workwave-tidal/core/icons'
import { useEditingStateWithCtx, resetCrudSelection } from '@/atoms'
import { preview } from '@/components/form/preview'
import { useReadOnlyTooltipData } from '@/components/smartUtils/plan/ReadOnlyTooltip'
import { useTexts } from '../hooks/useTexts'
import { useDeleteDriverModal } from '../../../modals/DeleteDriver'

type DriverViewHeaderProps = {
  drivers: uui.domain.client.rm.ExtendedDriver[]
}

export function BulkDriverViewHeader(props: DriverViewHeaderProps) {
  const { actions, titles } = useTexts()
  const { drivers } = props

  const driverIds = drivers.map(driver => driver.driver.id)

  const { setEditing } = useEditingStateWithCtx('driver')
  const { show: showDeleteModal, Modal: DeleteDriverModal } = useDeleteDriverModal()

  const onClose = useCallback(() => {
    resetCrudSelection('drivers')
  }, [])

  const { preventEditing, title } = useReadOnlyTooltipData()

  const onEdit = useCallback(() => setEditing(driverIds), [setEditing, driverIds])

  return (
    <preview.Header
      title={titles.headerTitle(drivers.length)}
      testId="driver-bulk-view-header"
      onClose={onClose}
    >
      <preview.ActionBar>
        <preview.ActionBarItem
          icon={<Edit />}
          onClick={onEdit}
          label={actions.edit}
          tooltip={preventEditing ? title : undefined}
          disableWhenReadOnly
          testId="edit-button"
          data-trackid="bulk-driver-edit-button"
        />
        <preview.ActionBarItem
          icon={<Delete />}
          onClick={showDeleteModal}
          label={actions.delete(1)}
          tooltip={preventEditing ? title : undefined}
          disableWhenReadOnly
          testId="delete-button"
          data-trackid="bulk-driver-delete-button"
        />
      </preview.ActionBar>
      <DeleteDriverModal driverIds={driverIds} />
    </preview.Header>
  )
}
